import { SERIA_PLUS_V3_IMAGE_BASE_URL, createDescription, createSlideMarkers, createTab } from './utils';

export const floorToCeilingWindowsTab = createTab({
  slides: [
    {
      ...createDescription([
        'Естественный свет — важнейшее условие здоровья и продуктивности. Поэтому дома',
        '«Серии плюс» отличаются разнообразием остекления. Окна наполняют квартиру',
        'дневным светом и делают пространство более уютным.',
      ]),
      imageAlt: 'Квартира Серии плюс с окнами в пол',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/floor-to-ceiling-windows/1.webp`,
      markers: createSlideMarkers([
        {
          left: 980,
          tooltip: { placement: 'right', text: 'Окно в пол' },
          top: 425,
        },
        {
          left: 1098,
          tooltip: { placement: 'right', text: 'Вид на лес' },
          top: 534,
        },
        {
          left: 1145,
          tooltip: { placement: 'right', text: 'Внутрипольный конвектор' },
          top: 705,
        },
      ]),
    },
    {
      ...createDescription([
        'Панорамные окна занимают большую часть стены',
        'и визуально увеличивают пространство квартиры,',
        'независимо от этажа и планировки.',
      ]),
      imageAlt: 'Панорамное окно в квартире Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/floor-to-ceiling-windows/2.webp`,
      markers: createSlideMarkers([
        {
          left: 600,
          tooltip: { placement: 'right', text: 'Панорамное окно' },
          top: 414,
        },
      ]),
    },
    {
      ...createDescription([
        'Эркеры — небольшие выступы на внешней части зданий. Внутри',
        'квартиры эркеры могут превратиться в уютную лаунж-зону или рабочий',
        'кабинет с видом на город.',
      ]),
      imageAlt: 'Эркер с окнами в квартире Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/floor-to-ceiling-windows/3.webp`,
      markers: createSlideMarkers([
        {
          left: 983,
          tooltip: { placement: 'right', text: 'Окна в эркерах' },
          top: 507,
        },
        {
          left: 1149,
          tooltip: { placement: 'right', text: 'Внутрипольный конвектор' },
          top: 722,
        },
      ]),
    },
    {
      ...createDescription([
        'Снаружи угловые окна визуально делают здания более лёгкими, а',
        'внутри — добавляют акцент в интерьер и открывают из одной',
        'комнаты вид сразу на две стороны улицы.',
      ]),
      imageAlt: 'Угловое окно в квартире Серии плюс',
      imageSrc: `${SERIA_PLUS_V3_IMAGE_BASE_URL}/floor-to-ceiling-windows/4.webp`,
      markers: createSlideMarkers([
        {
          left: 832,
          tooltip: { placement: 'right', text: 'Угловое окно' },
          top: 517,
        },
      ]),
    },
  ],
  title: 'Окна в пол',
});
